// src/components/Home/AboutSection.jsx
import React from "react";
import {
  FaMapMarkerAlt,
  FaShippingFast,
  FaUsers,
  FaAward,
} from "react-icons/fa";
import "./AboutSection.css";

const AboutSection = () => {
  const locations = [
    { name: "Nairobi ICD", icon: <FaMapMarkerAlt /> },
    { name: "Mombasa Port", icon: <FaMapMarkerAlt /> },
    { name: "JKIA", icon: <FaMapMarkerAlt /> },
  ];

  const stats = [
    { number: "2015", label: "Established", icon: <FaAward /> },
    { number: "50,000+", label: "Sq Ft Warehousing", icon: <FaShippingFast /> },
    { number: "20+", label: "Vehicle Fleet", icon: <FaUsers /> },
  ];

  return (
    <section className="about-section section section-light">
      <div className="container">
        {/* Section Header */}
        <div className="section-header text-center">
          <h2>About Falmouth Global Solutions</h2>
          <p className="section-subtitle">
            Your Premier Partner in Freight Shipping, Customs Clearance & Global
            Forwarding services in Kenya
          </p>
        </div>

        <div className="about-content">
          {/* Main About Text */}
          <div className="about-text">
            <div className="about-card card">
              <h3>
                Leading Customs Clearing Agent & Shipping Services company in
                Kenya
              </h3>
              <p>
                Falmouth Global Solutions is a top-rated logistics company
                providing comprehensive shipping services, customs clearing, and
                supply chain solutions in Kenya and beyond since 2015. We are
                recognized as one of the leading customs clearing agents and
                freight forwarders in Kenya, offering seamless sea freight, air
                freight, and road transport services.
              </p>
              <p>
                Also serving Nairobi (ICD), Mombasa Port and JKIA for clearing
                agent, customs agent and shipping services in Kenya — sea
                freight (FCL/LCL), air freight and road transport.
              </p>
            </div>

            {/* Stats Cards */}
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-card card">
                  <div className="stat-icon">{stat.icon}</div>
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Locations Section */}
          <div className="locations-section">
            <div className="locations-card card">
              <h4>Locations We Operate In</h4>
              <div className="locations-list">
                {locations.map((location, index) => (
                  <div key={index} className="location-item">
                    <div className="location-icon">{location.icon}</div>
                    <span className="location-name">{location.name}</span>
                  </div>
                ))}
              </div>

              {/* Service Areas Map */}
              <div className="service-areas">
                <h5>Service Coverage</h5>
                <div className="areas-grid">
                  <div className="area-tag">Kenya</div>
                  <div className="area-tag">Uganda</div>
                  <div className="area-tag">Tanzania</div>
                  <div className="area-tag">Rwanda</div>
                  <div className="area-tag">East Africa</div>
                  <div className="area-tag">Global</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="features-grid">
          <div className="feature-card card">
            <div className="feature-icon">
              <FaShippingFast />
            </div>
            <h4>End-to-End Solutions</h4>
            <p>
              Complete logistics services from origin to final destination with
              full visibility and control.
            </p>
          </div>

          <div className="feature-card card">
            <div className="feature-icon">
              <FaAward />
            </div>
            <h4>Licensed & Compliant</h4>
            <p>
              100% KRA-aligned processes with accurate HS classification and
              audit-ready documentation.
            </p>
          </div>

          <div className="feature-card card">
            <div className="feature-icon">
              <FaUsers />
            </div>
            <h4>Expert Team</h4>
            <p>
              Experienced professionals dedicated to providing personalized
              service and support for your business.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
